import { PAID_HOMEPAGE_SLUG, PAID_LP_SLUGS } from '@lib/constants'

interface EligibilityGoogleOneTapOptions {
  isAnonymous: boolean
  isChrome: boolean
  pageSlug?: string
  isGoogleOneTapEnabled?: boolean
  isSSO?: boolean
}

export const isPaidLPGoogleOneTapEligible = (pageSlug: string) => {
  return (pageSlug === PAID_HOMEPAGE_SLUG || pageSlug?.startsWith(PAID_LP_SLUGS)) ?? false
}

export const isEligibleGoogleOneTap = ({
  isAnonymous,
  isChrome,
  isGoogleOneTapEnabled,
  isSSO,
  pageSlug,
}: EligibilityGoogleOneTapOptions) => {
  const isUserStateEligible = isSSO || isAnonymous
  return isUserStateEligible && isChrome && (isGoogleOneTapEnabled || isPaidLPGoogleOneTapEligible(pageSlug ?? ''))
}
